export default {
  EVENTS: {
    CHECKOUT: {
      // Flow
      START: 'checkout.start',
      STEP_CHANGED: 'checkout.step_changed',

      // Order
      CREATE_ORDER: 'checkout.create_order',
      CREATE_ORDER_SUCCESS: 'checkout.create_order_success',
      CREATE_ORDER_ERROR: 'checkout.create_order_error',

      // Stripe Payment
      INITIATE_STRIPE: 'checkout.initiate_stripe',
      STRIPE_SUCCESS: 'checkout.stripe_success',
      STRIPE_ERROR: 'checkout.stripe_error',

      // Final Order (after payment)
      FINALIZE_ORDER: 'checkout.finalize_order',
      FINALIZE_SUCCESS: 'checkout.finalize_success',
      FINALIZE_ERROR: 'checkout.finalize_error',

      // Promo Code
      APPLY_PROMO: 'checkout.apply_promo',
      APPLY_PROMO_SUCCESS: 'checkout.apply_promo_success',
      APPLY_PROMO_ERROR: 'checkout.apply_promo_error',
      REMOVE_PROMO: 'checkout.remove_promo',

      // Validation
      VALIDATE_STEP: 'checkout.validate_step',
      VALIDATION_ERROR: 'checkout.validation_error',
    }
  },
  ENDPOINTS: {
    CHECKOUT: {
      STRIPE_CREATE_PAYMENT_INTENT: '/checkout/stripe/create-payment-intent'
    }
  },
  STEPS: [
    { id: 1, title: 'Email', description: 'Votre adresse email' },
    { id: 2, title: 'Paiement', description: 'Paiement sécurisé' },
    { id: 3, title: 'Confirmation', description: 'Commande confirmée' },
  ],
  ORDER_TYPES: {
    GIFT_CARD: 'gift_card',
    AIRTIME: 'airtime',
    DATA_BUNDLE: 'data_bundle',
    CARRIER_BUNDLE: 'carrier_bundle',
    ESIM: 'esim',
    CUSTOM_CARD: 'custom_card'
  }
};
